// Hook that runs a given effect exactly once.

import { useEffect, useRef } from "react";

export function useOnlyOnce(effect: () => void) {
  const ranOnce = useRef<boolean>(false);

  useEffect(() => {
    if (!ranOnce.current) {
      ranOnce.current = true;
      effect();
    }
  }, [effect /* Here for linter but won't have an effect */]);
}
